<div class="loader" [kgrLoading]="true" i18n>Logging Out ...</div>
